import { orchestrator } from 'satcheljs';
import { manageSecurity } from '../actions/manageSecurity';
import { logUsage } from 'owa-analytics';
import datapoints from '../datapoints';

let manageSecurityUrl = 'https://go.microsoft.com/fwlink/?linkid=872493';

export default orchestrator(manageSecurity, async function manageSecurity() {
    logUsage(datapoints.PremiumDashSecurityManage.datapoint.name);
    window.open(manageSecurityUrl, '_blank');
});
